import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import dateFormat from "dateformat"
//import { baseURL } from "../api";
export const DownloadLink = () => {
  const search = useLocation().search;
  const expiredDate = new URLSearchParams(search).get("expiratedDate"); //sera décrotiquer depuis l'url
  const fichierId = new URLSearchParams(search).get("fichierId");
  const fileName = new URLSearchParams(search).get("fileName");
  const baseURL = "http://localhost:5000/"; // Example for Flask


  useEffect(() => {
    const maintenant = new Date()
    const currentDate = dateFormat(maintenant, "yyyy-mm-dd");
     if (expiredDate > currentDate) {
      window.location.href = baseURL+`api/fichiers/download/${fichierId}/${fileName}`;
      //setTimeout(() => {
        //window.location.href = `https://gexonline.gexpertise.fr`;
      //}, 10000);
    }
    //  page expired file puis  redirection vers la page d'accueil de gexonline
    else if (expiredDate <= currentDate) window.location.href = `https://gexonline.gexpertise.fr/expired`;
  });

  return (
    <div className="accordion-demo">
      <div className="card" style={{height:"100vh"}}>
    <center>
    <ProgressSpinner />
        <p>Téléchargement en cours...</p>
    </center>
      </div>
    </div>
  );
};
